export function getMinPriceInfo(dealInfo) {
  const enabledDealInfo = _.filter(dealInfo, { enabled: true });
  if (!enabledDealInfo.length) {
    return null;
  }

  return _.minBy(enabledDealInfo, 'price');
}

export function hasEnabledPriceInfo(dealInfo) {
  return _.some(dealInfo, { enabled: true });
}

function buildGetPriceInfo(type) {
  const query = {
    enabled: true,
    type,
  };

  return function (dealInfo) {
    return _.find(dealInfo, query) || null;
  };
}

export const getSubscriptionPriceInfo = buildGetPriceInfo('subscription');
export const getSalePriceInfo = buildGetPriceInfo('sale');
export const getRentPriceInfo = buildGetPriceInfo('rent');



// WEBPACK FOOTER //
// ./src/shared/utils/deal-info-helpers.js